// the customers an Email Broadcast's coupon check needs a choice for. A choice is
// 'replace' (swap their coupon for it), 'email' (the email, no coupon, account
// untouched) or 'remove' (no email)

const EMAIL = {value: 'email', text: 'Email, no coupon'};
const REMOVE = {value: 'remove', text: 'Remove'};

/**
 * The choices to show: one group per coupon held (the most held first), then the
 * customers with no Stripe customer.
 */
export function couponChoiceGroups(rows) {
  const holders = new Map();
  rows.filter(row => row.status === 'has coupon').forEach(row => {
    const {id} = row.existing_coupon;
    if (!holders.has(id)) {
      holders.set(id, {key: `coupon:${id}`, coupon: row.existing_coupon, rows: [], choices: [{value: 'replace', text: 'Replace'}, EMAIL, REMOVE]});
    }
    holders.get(id).rows.push(row);
  });
  const groups = [...holders.values()].sort((a, b) => b.rows.length - a.rows.length);

  const noStripe = rows.filter(row => row.status === 'no stripe customer');
  if (noStripe.length) {
    groups.push({key: 'no-stripe', title: 'No Stripe customer to hold a coupon', rows: noStripe, choices: [EMAIL, REMOVE]});
  }
  return groups;
}

const uidsChoosing = (rows, decisions, choice) => rows.filter(row => decisions[row.uid] === choice).map(row => row.uid);

export const removedUids = (rows, decisions) => uidsChoosing(rows, decisions, 'remove');

export const emailOnlyUids = (rows, decisions) => uidsChoosing(rows, decisions, 'email');

/** Whose coupon is replaced, with the coupon the sender saw them holding. */
export function replacements(rows, decisions) {
  return rows
    .filter(row => row.status === 'has coupon' && decisions[row.uid] === 'replace')
    .map(row => ({uid: row.uid, couponId: row.existing_coupon.id}));
}

export function undecidedCount(rows, decisions) {
  return rows.filter(row => ['has coupon', 'no stripe customer'].includes(row.status) && !decisions[row.uid]).length;
}

export const isAllRemoved = ({rows}, decisions) => rows.every(row => decisions[row.uid] === 'remove');

/** Whether a check was made for exactly these customers. */
export function isSameCustomers(rows, recipients) {
  const uids = new Set(rows.map(row => row.uid));
  return rows.length === recipients.length && recipients.every(({uid}) => uids.has(uid));
}
